export const CREATED = 'created';
export const ACTIVATED = 'activated';
export const INACTIVATED = 'inactivated';
export const CANCELED = 'canceled';
export const SUSPENDED = 'suspended';
export const EXPIRED = 'expired';
export const INTRIAL = 'inTrial';
export const CANCELLATION_REQUESTED = 'cancellationRequested';
export const CONCLUDED = 'concluded';
export const INPROGRESS = 'inProgress';

export const AVAILABLE = 'available';

export const PENDING = 'pending';
export const ACCEPTED = 'accepted';
export const RECONCILED = 'reconciled';
export const IGNORED = 'ignored';

export const MEMED = 'memed';
export const RECEITADIGITAL = 'receitaDigital';

export const RECEIPT = 'receipt';
export const PAYMENT = 'payment';

export const SUMMARY = 'summary';
export const BALANCE = 'balance';
export const BEFOREBALANCE = 'beforeBalance';
export const ENDBALANCE = 'endBalance';
export const INITIALBALANCE = 'initialBalance';

export const BILLETBANK = 'billetBank';
export const CREDITCARD = 'creditCard';
export const DEBITCARD = 'debitCard';
export const DIRECTDEBIT = 'directDebit';
export const BANKDEPOSIT = 'bankDeposit';
export const PAYPAL = 'paypal';
export const BANKTRANSFER = 'bankTransfer';
export const CASH = 'cash';
export const BANKCHECK = 'bankCheck';
export const BALANCEWALLETS = 'balanceWallets';
export const PIX = 'pix';
export const ELECTRONICTRANSFER = 'electronicTransfer';
export const OTHER = 'other';

export const INCOMING = 'incoming';
export const OUTGOING = 'outgoing';

export const APOSITIVE = 'aPositive';
export const ANEGATIVE = 'aNegative';
export const BPOSITIVE = 'bPositive';
export const BNEGATIVE = 'bNegative';
export const ABPOSITIVE = 'abPositive';
export const ABNEGATIVE = 'abNegative';
export const OPOSITIVE = 'oPositive';
export const ONEGATIVE = 'oNegative';

export const APPROXIMATETAXES_DISABLED = 'disabled';
export const APPROXIMATETAXES_COMPLETE = 'complete';
export const APPROXIMATETAXES_SIMPLIFIED = 'simplified';

export const YEAR = 'year';
export const MONTH = 'month';
export const DAY = 'day';
export const COSTCENTER = 'costCenter';

export const NATIONAL = 'national';
export const STATE = 'state';
export const MUNICIPAL = 'municipal';

export const ACCOUNT_TYPE_STUDENT = 'student';

export const ROLE_ADMIN = 'Admin';
export const ROLE_PROFESSIONAL = 'Professional';
export const ROLE_RECEPTIONIST = 'Receptionist';
export const ROLE_USER = 'User';
export const ROLE_STUDENT = 'Student';
export const ROLE_OTHER_HEALTH_PROFESSIONAL = 'Other health professional';
export const ROLE_CLINIC_ADMINISTRATOR = 'Clinic administrator';
export const ROLE_FINANCIAL = 'Financial';
export const ROLE_ACCOUNTANT = 'Accountant';
export const ROLE_PARTNERSHIP = 'Partnership';
export const ROLE_FINANCIAL_ADMINISTRATOR = 'Financial administrator';
export const ROLE_STOCK = 'Stock';

export const PROFILE_DOCTOR = 'doctor';
export const PROFILE_ADMINISTRADOR = 'administrador';
export const PROFILE_OTHER = 'other';
export const PROFILE_RECEPTIONIST = 'receptionist';
export const PROFILE_ACCOUNTANT = 'accountant';
export const PROFILE_FINANCIAL = 'financial';
export const PROFILE_STUDENT = 'student';
export const PROFILE_USER = 'user';
export const PROFILE_PARTNERSHIP = 'partnership';
export const PROFILE_FINANCIAL_ADMINISTRATOR = 'financialAdministrator';

export const ACCOUNTANTS = 'accountants';
